module.exports = __webpack_public_path__ + "img/PR13.fc6674ad.png";